import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Heart, Eye, ChatCircle } from "@phosphor-icons/react";
import { Button } from "../ui/button";
import { api } from "../../lib/api";
import { NETWORKS, NETWORK_IDS, NetworkDot, fmtDate, errMsg } from "./socialShared";

function NetCard({ id, s }) {
  return (
    <div className="rounded-xl border bg-card p-4" data-testid={`stats-card-${id}`}>
      <div className="flex items-center gap-2 font-semibold"><NetworkDot id={id} size={18} />{NETWORKS[id].label}</div>
      <div className="mt-3 text-3xl font-bold font-display" data-testid={`stats-${id}-posts`}>{s.posts}</div>
      <div className="text-xs text-muted-foreground">posts publiés</div>
      <div className="mt-3 flex gap-4 text-sm">
        <span className="inline-flex items-center gap-1" data-testid={`stats-${id}-likes`}><Heart size={14} />{s.likes}</span>
        <span className="inline-flex items-center gap-1"><ChatCircle size={14} />{s.comments}</span>
        <span className="inline-flex items-center gap-1" data-testid={`stats-${id}-views`}><Eye size={14} />{s.views}</span>
      </div>
    </div>
  );
}

export function SocialStats({ refreshKey }) {
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/social/stats", { params: { days } }).then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [days, refreshKey]);
  if (!data) return null;
  return (
    <div className="space-y-5" data-testid="social-stats">
      <div className="flex gap-1">
        {[7, 30, 90, 365].map((d) => <Button key={d} size="sm" variant={days === d ? "default" : "ghost"} onClick={() => setDays(d)} data-testid={`stats-days-${d}`}>{d === 365 ? "1 an" : `${d} jours`}</Button>)}
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {NETWORK_IDS.map((id) => <NetCard key={id} id={id} s={data.per_network[id]} />)}
      </div>
      <div className="rounded-xl border bg-card">
        <div className="border-b px-4 py-2 text-sm font-semibold">Meilleurs posts</div>
        {data.top_posts.length === 0 && <div className="p-6 text-center text-sm text-muted-foreground" data-testid="stats-empty">Pas encore de post publié sur cette période.</div>}
        {data.top_posts.map((p) => (
          <div key={p.id} className="flex items-center gap-3 border-b px-4 py-2 text-sm last:border-0" data-testid={`stats-top-${p.id}`}>
            <span className="w-28 shrink-0 text-xs text-muted-foreground">{fmtDate(p.published_at)}</span>
            <span className="flex gap-1">{p.networks.map((n) => <NetworkDot key={n} id={n} size={12} />)}</span>
            <span className="min-w-0 flex-1 truncate">{p.text}</span>
            <span className="inline-flex items-center gap-1"><Heart size={12} />{p.likes}</span>
            <span className="inline-flex items-center gap-1"><Eye size={12} />{p.views}</span>
          </div>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">Les chiffres sont mis à jour automatiquement toutes les 6 heures pendant 30 jours après publication.</p>
    </div>
  );
}
